import TreatmentGroupDetailSections from './TreatmentGroupDetailSections';

export default TreatmentGroupDetailSections;
